"use client";

import { useSyncExternalStore } from "react";
import { session } from "@/shared/lib/storage";
import { STORAGE_KEYS } from "@/shared/lib/storage.constants";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "fbclid",
  "gclid",
] as const;

export type UtmParams = Record<string, string>;

const EMPTY_PARAMS: UtmParams = {};

let cachedParams: UtmParams = {};
let initialized = false;

function initParams(): UtmParams {
  if (initialized) return cachedParams;
  initialized = true;

  const url = new URL(window.location.href);
  const existing: UtmParams = session.getJSON<UtmParams>(STORAGE_KEYS.UTM_PARAMS) ?? {};

  let updated = false;
  for (const key of UTM_KEYS) {
    const val = url.searchParams.get(key);
    if (val) {
      existing[key] = val;
      updated = true;
    }
  }

  if (updated) {
    session.setJSON(STORAGE_KEYS.UTM_PARAMS, existing);
  }

  cachedParams = existing;
  return cachedParams;
}

function subscribe() {
  return () => {};
}

function getSnapshot(): UtmParams {
  return initParams();
}

function getServerSnapshot(): UtmParams {
  return EMPTY_PARAMS;
}

export function useUtmParams(): UtmParams {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
